import React, { useState } from 'react'
import styles from './LibraryTab.module.scss'
import { SearchInput, IconButton } from 'components'
import { icons } from 'assets'
import TabContainer from '../TabContainer'
import TabToolsContainer from '../TabToolsContainer'
import ItemsSection from './ItemsSection'
import { inject } from 'mobx-react'
import {
  EDITOR_STORE,
  BRAND_STORE,
  PERSON_STORE,
  popupSelectorTypes,
  getEntityClass,
  EDITOR_MONITOR_STORE,
  PROJECT_PAGE_STORE
} from 'store'
import { observer } from 'mobx-react-lite'
import HoverOptionsMenu from './HoverOptionsMenu'
import { SectionTitle } from 'components/common'
import TabBodyContainer from '../TabBodyContainer'
import AddRemoveItemsHandler from './AddRemoveItemsHandler'
import {
  LibraryTabProps,
  itemLabels,
  addItemsMenuOptions,
  filterMenuOptions,
  filterMenuKeyTypes
} from './types'

const LibraryTabComponent = (props: LibraryTabProps) => {
  const {
    [EDITOR_STORE]: { actors, directors, producers, brands },
    [BRAND_STORE]: { getBrands, setBrandToView },
    [PERSON_STORE]: { getAll },
    [EDITOR_MONITOR_STORE]: { getShotsCountForEntity }
  } = props

  const [searchText, setSearchText] = useState('')
  const [hoverMenu, setHoverMenu] = useState('none')
  const [popupSelector, setPopupSelector] = useState('')
  const [filterOptions, setFilterOptions] = useState({
    usedProducts: true,
    unusedProducts: true,
    usedPersons: true,
    unusedPersons: true
  })
  const [scrollTop, setScrollTop] = useState(0)

  const handleHoverMenuSelect = (value) => {
    switch (value) {
      case popupSelectorTypes.addProduct:
        setBrandToView()
        getBrands()
        break
      case popupSelectorTypes.addPerson:
        getAll()
        break
      case filterMenuKeyTypes.usedProducts:
        setFilterOptions((s) => ({ ...s, [value]: !s[value] }))
        break
      case filterMenuKeyTypes.unusedProducts:
        setFilterOptions((s) => ({ ...s, [value]: !s[value] }))
        break
      case filterMenuKeyTypes.usedPersons:
        setFilterOptions((s) => ({ ...s, [value]: !s[value] }))
        break
      case filterMenuKeyTypes.unusedPersons:
        setFilterOptions((s) => ({ ...s, [value]: !s[value] }))
        break

      default:
        break
    }
    setPopupSelector(value)
  }

  const userFilter = (items) => {
    return items
      .filter((item) => {
        const itemType = getEntityClass(item) + 's'
        const usedStatus = getShotsCountForEntity(item) ? 'used' : 'unused'

        const key = `${usedStatus}${itemType}`
        return filterOptions[key]
      })
      .filter((item) =>
        item.name.toLowerCase().includes(searchText.trim().toLowerCase())
      )
  }
  return (
    <div className={styles.tab}>
      <TabContainer>
        <TabToolsContainer>
          <SearchInput
            onChange={(text) => setSearchText(text.trim().toLowerCase())}
          />
          <IconButton
            icon={icons.filter}
            onClick={() => setHoverMenu('none')}
            onMouseEnter={() => setHoverMenu('filter')}
            style={hoverMenu === 'filter' ? { color: styles.blue } : {}}
          />
          <IconButton
            icon={icons.plusCircle}
            onClick={() => setHoverMenu('none')}
            onMouseEnter={() => setHoverMenu('addItems')}
            style={hoverMenu === 'addItems' ? { color: styles.blue } : {}}
          />

          {{
            addItems: (
              <HoverOptionsMenu
                hide={() => setHoverMenu('none')}
                onSelect={handleHoverMenuSelect}
                options={addItemsMenuOptions}
              />
            ),
            filter: (
              <HoverOptionsMenu
                hide={() => setHoverMenu('none')}
                onSelect={handleHoverMenuSelect}
                checkboxStatuses={filterOptions}
                options={filterMenuOptions}
              />
            )
          }[hoverMenu] || null}
        </TabToolsContainer>
        <TabBodyContainer
          onScroll={({ target }) => setScrollTop(target.scrollTop)}
        >
          <SectionTitle text='persons' />
          <ItemsSection
            scrollTop={scrollTop}
            items={userFilter(actors)}
            label={itemLabels.actors}
          />
          <ItemsSection
            scrollTop={scrollTop}
            items={userFilter(directors)}
            label={itemLabels.directors}
          />
          <ItemsSection
            scrollTop={scrollTop}
            items={userFilter(producers)}
            label={itemLabels.producers}
          />

          <SectionTitle text='brands' />
          {brands.map((brand) => (
            <ItemsSection
              key={brand.id}
              scrollTop={scrollTop}
              items={userFilter(brand.products)}
              label={brand.name}
            />
          ))}
        </TabBodyContainer>
      </TabContainer>

      <AddRemoveItemsHandler
        popupSelector={popupSelector}
        onClose={() => setPopupSelector('none')}
      />
    </div>
  )
}

const LibraryTab = inject(
  EDITOR_STORE,
  BRAND_STORE,
  PERSON_STORE,
  EDITOR_MONITOR_STORE,
  PROJECT_PAGE_STORE
)(observer(LibraryTabComponent))
export default LibraryTab
